"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = void 0;

var _util = require("../../../util");

const css = ({
  cssProps,
  theme
}) => {
  const {
    align,
    color,
    family,
    lineHeight,
    size,
    transform,
    truncate,
    variant = 'body',
    weight
  } = cssProps;
  return {
    color: (0, _util.color)(theme, color || theme.colors.text[variant]) || 'currentColor',
    fontFamily: theme.fonts[family || variant],
    fontSize: theme.fontSizes[size || variant],
    fontWeight: theme.fontWeights[weight || variant],
    lineHeight: theme.lineHeights[lineHeight || variant],
    textAlign: align,
    textTransform: transform,
    ...(truncate ? {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    } : {})
  };
};

exports.css = css;
//# sourceMappingURL=Text.style.js.map